"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeTooltip = exports.UpgradeTooltipContent = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var UpgradeContainer_1 = require("./UpgradeContainer");
var UpgradeTelemetry_1 = require("./UpgradeTelemetry");
var UpgradeButton_1 = require("./UpgradeButton");
var AdminOnly_1 = require("Utils/AdminOnly");
var CreatorOnly_1 = require("Utils/CreatorOnly");
var UpgradeConstants_1 = require("./UpgradeConstants");
var c = (0, BemBuilder_1.default)("upgrade-tooltip");
var UpgradeTooltipContent = function (_a) {
    var onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, telemetryOrigin = _a.telemetryOrigin, texts = _a.texts;
    return (react_1.default.createElement("div", { className: c("content"), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, texts.heading),
        react_1.default.createElement(AdminOnly_1.AdminOnly, null,
            texts.subtitleAdmin != undefined && (react_1.default.createElement(kaleidoscope_1.Text, { align: "center", size: "s" }, texts.subtitleAdmin)),
            react_1.default.createElement(UpgradeButton_1.UpgradeButton, { telemetryOrigin: telemetryOrigin })),
        react_1.default.createElement(CreatorOnly_1.CreatorOnly, null,
            react_1.default.createElement(kaleidoscope_1.Text, { align: "center", size: "s" }, texts.subtitleCreator))));
};
exports.UpgradeTooltipContent = UpgradeTooltipContent;
var UpgradeTooltip = function (_a) {
    var children = _a.children, telemetryOrigin = _a.telemetryOrigin, texts = _a.texts, disabled = _a.disabled;
    var _b = __read((0, react_1.useState)(false), 2), show = _b[0], setShow = _b[1];
    var onMouseEnterHander = function () {
        onMouseLeaveHander.cancel();
        setShow(true);
    };
    var onMouseLeaveHander = (0, lodash_1.debounce)(function () {
        setShow(false);
    }, UpgradeConstants_1.MAX_MOUSE_MOVE_WAITING);
    if (disabled)
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    return (react_1.default.createElement(UpgradeContainer_1.UpgradeContainer, null,
        react_1.default.createElement(kaleidoscope_1.Tooltip, { show: show, size: kaleidoscope_1.TooltipSize.Small, className: c(), targetClassName: c("target"), content: react_1.default.createElement(UpgradeTelemetry_1.UpgradeDiscoveryViewedTelemetry, { telemetryOrigin: telemetryOrigin },
                react_1.default.createElement(exports.UpgradeTooltipContent, { onMouseEnter: onMouseEnterHander, onMouseLeave: onMouseLeaveHander, telemetryOrigin: telemetryOrigin, texts: texts })), position: kaleidoscope_1.TooltipPosition.Bottom },
            react_1.default.createElement("div", { style: { height: "100%" }, onMouseEnter: onMouseEnterHander, onMouseLeave: onMouseLeaveHander }, children))));
};
exports.UpgradeTooltip = UpgradeTooltip;
